import { defineComponent as _defineComponent } from 'vue'
import ExtensionBar from "#src/components/ExtensionBar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { ExtensionBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})